<template>
  <div class="bi-actions">
    <div v-for="action in getActions" :key="action.id">
      <BoardItemAction :action="action" :boardId="item.ownerBoardId"></BoardItemAction>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import { IBoardItemDto } from '@/apiclient/apiclient_generated';
  import BoardItemAction from './BoardItemAction.vue';

  @Component({
    components: {
      BoardItemAction,
    },
  })
  export default class BoardItemActions extends Vue {
    @Prop()
    item: IBoardItemDto;

    get getActions() {
      return this.lodash.sortBy(this.item.actions, 'sortOrder');
    }
  }
</script>